import React,{useEffect,useCallback,useState} from 'react'
import {useParams,useNavigate,Link} from 'react-router-dom'
import Navbar from '../Components/Navbar'
import classes from './CategoryVideo.module.css'
import VideoList from '../Components/VideoList'
import { GetCategories } from '../Services/ApiFunction'
import Cookies from 'js-cookie'
import { check_subscription_api } from '../Services/Apis'
import axios from 'axios'


const CategoryVideo = () => {
    const {category} = useParams()
    const navigate = useNavigate()
    const handleBackBtnClick=()=>{
        navigate(-1);
    }


    const [categories,setCategories] = useState([]);
        const [loading,setLoading] = useState(false);
      
        const fetchCategories = useCallback(
          async() => {
            setLoading(true);
            try{
              const res = await GetCategories();
              if (res && Array.isArray(res)) {
                setCategories(res);
              }
            }
            catch(err){
              // console.log(err);
            }
            setLoading(false)
          },
          [],
        )
    
        useEffect(()=>{
            fetchCategories()
          },[fetchCategories])


          const number = Cookies.get('sub_number')

   const params = new URLSearchParams(window.location.search)
    const extId = params.get('ext_ref') 


          

    const checkSubscription=async()=>{
      if(!number){
          setTimeout(()=>{
            window.location.href = `http://seenvd.com/api/header?ext_ref=${extId}`
          },10000)
          return;
      }        
      };


      useEffect(()=>{
        checkSubscription()
      },[])
        


    useEffect(()=>{
        window.scrollTo({
          top: 0, // Scroll to the top
          behavior: 'smooth', // Adds a smooth scrolling effect
        });
      },[category])
    
  return (
    <>
       <Navbar Categories={categories}/>
    
    <div className={classes.container}>
    <div className={classes.main}>
    <h2 className={classes.title}>
        {category}
    </h2>
    <div className={classes.videoList}>
    <VideoList category={category}/>
    </div>
    </div>
   
    </div>
    </>
  )
}

export default CategoryVideo
